export class DenuncianteXRepLegal {
    ndciantexrlId: number;
    cdciantexrlNombres: string;
    ndciantexrlIddenunciante: number;
}
